import { useMemo } from 'react';
import type { ScreenState } from '@hana/ui';

export interface P2PAccess {
  /** Quyền tiền: giá mua và margin. Giá bán luôn hiện cho người được tra giá. */
  money: boolean;
  /** Ép trạng thái màn như prop `state` của board (xem thử / chụp ảnh). */
  force: ScreenState | null;
}

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

/** TODO(A): quyền thật (`money`, quyền tra giá) đến từ phiên đăng nhập khi luồng A có; tạm đọc `?money=view&state=…` như prop của board. */
export function useP2PAccess(search: string = typeof location === 'undefined' ? '' : location.search): P2PAccess {
  return useMemo(() => {
    const p = new URLSearchParams(search);
    const st = p.get('state') as ScreenState | null;
    return { money: p.get('money') === 'view', force: st && STATES.includes(st) ? st : null };
  }, [search]);
}
